angular
  .module('iqxCore')
  .filter('trustHtml', function trustHtml($sce) {
    return function (value) {
      return $sce.trustAs('html', value)
    }
  })
  .filter('reverse', function () {
    return function (items) {
      return items.slice().reverse()
    }
  })
  .controller('SmsCtrl', function ($scope, FormSvc, ApiSvc, AvatarService, $http, toastSvc, $timeout, $routeParams, $location, consultantListSvc) {
    $scope.checkPermissions('OWNER')
    $scope.generateAvatarSVG = AvatarService.generateAvatarSVG
    $scope.loadingPage = true
    $scope.ShowClassCodeBox = false
    $scope.SelectedClassCode = null
    $scope.smsCharLimit = 0
    $scope.currentChars = 0
    $scope.message = null // the message to send
    $scope.messageSending = false
    $scope.smsHardCharLimit = 1280 // 1280 is the max length of a single sms message
    $scope.consultants = []
    $scope.selectedConsultant = null

    $scope.getContactClasses = function () {
      // fetch NetOwnerSMSContactClasses
      return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetOwnerSMSContactClasses', fetchTarget: 'ClassCodes', multiRow: true }).then(function () {
        if (Object.keys($scope.ClassCodes).length === 1) {
          $scope.ShowClassCodeBox = false
          $scope.SelectedClassCode = $scope.ClassCodes[0].ClassCode
          // we have 1
        } else {
          $scope.SelectedClassCode = $scope.ClassCodes[0].ClassCode
          $scope.ShowClassCodeBox = true
          // show the box
        }
      })
    }

    function nl2br(strIn) {
      try {
        return strIn.replace(/(\r\n)/gm, '<br />')
      } catch (error) {
        return strIn
      }
    }

    var emojisToUnicode = function (inputString) {
      var rex = /[\uD83C\uD83D\uD83E][\uDC00-\uDFFF]|[\u2600-\u27BF]/g
      var updated = inputString.replace(rex, function (match) {
        if (match.length === 2) {
          // Handle surrogate pairs for emojis in BMP
          var highSurrogate = match.charCodeAt(0)
          var lowSurrogate = match.charCodeAt(1)
          var codePoint = (highSurrogate - 0xd800) * 0x400 + (lowSurrogate - 0xdc00) + 0x10000
          return '[e-000' + codePoint.toString(16) + ']'
        } else {
          // Handle emojis outside BMP
          return '[e-000' + match.codePointAt(0).toString(16) + ']'
        }
      })
      return updated
    }

    var fromCodePoint = function (codePoint) {
      if (codePoint < 0x10000) {
        return String.fromCharCode(codePoint)
      } else {
        // Handle supplementary planes in IE6
        var highSurrogate = Math.floor((codePoint - 0x10000) / 0x400) + 0xd800
        var lowSurrogate = ((codePoint - 0x10000) % 0x400) + 0xdc00
        return String.fromCharCode(highSurrogate, lowSurrogate)
      }
    }

    var unicodeToEmojis = function (unicodeString) {
      // Replace [e-00000000] with just the hexadecimal number
      unicodeString = unicodeString.replace(/\[e-000(.*?)\]/g, function (match, strWithUnicode) {
        return strWithUnicode
      })

      // Split the string into an array of hex codes
      var codes = unicodeString.match(/[0-9A-Fa-f]{5}/g)

      if (!codes) {
        return unicodeString
      }

      // Loop through each hex code and convert to character
      for (var i = 0; i < codes.length; i++) {
        var code = codes[i]

        // Convert hexadecimal code to emoji
        var emoji = fromCodePoint(parseInt(code, 16))

        // Replace the original hexadecimal code with the emoji in the original string
        unicodeString = unicodeString.replace(code, emoji)
      }
      return unicodeString
    }

    function errorReporter(e) {
      console.error(e)
      var msg = ''
      if (typeof e === 'object' && e !== null) {
        msg = JSON.stringify(e)
      } else {
        msg = e.toString()
      }
      toastSvc.error('Error', msg)
    }

    function safeDecodeURIComponent(str) {
      try {
        return decodeURIComponent(str)
      } catch (e) {
        return str // Return the original string if decoding fails
      }
    }

    $scope.fetchSMS = function () {
      if ($routeParams && $routeParams.consultant) {
        $scope.selectedConsultant = $routeParams.consultant
      }

      var query = $scope.selectedConsultant ? '?pStaffID=' + $scope.selectedConsultant : ''
      return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetOwnerSMSList' + query, fetchTarget: 'smsList', multiRow: true }).then(function () {
        $scope.smsList = Object.values(
          $scope.smsList.reduce((acc, item) => {
            if (!acc[item.PERSONID] || new Date(item.TIMESTAMP) > new Date(acc[item.PERSONID].TIMESTAMP)) {
              acc[item.PERSONID] = item
            }
            return acc
          }, {})
        )
      })
    }

    $scope.fetchSMSConversation = async function (sms) {
      return ApiSvc.fetch($scope, {
        fetchAPI: 'callresult/NetOwnerSMSConversation?x=10000&y=1&ConversationType=SMS&RecordID=' + sms.PERSONID + '&RecordType=P',
        fetchTarget: 'smsConversation',
        dateFields: ['ContactDate'],
        timeFields: ['ContactTime'],
        multiRow: true
      }).then(function () {
        angular.forEach($scope.smsConversation, function (row, index) {
          row.DateTime = new Date(row.ContactDate.getMonth() + 1 + '/' + row.ContactDate.getDate() + '/' + row.ContactDate.getFullYear() + ' ' + row.ContactTime.getHours() + ':' + row.ContactTime.getMinutes() + ':00')
          row.MessageText = nl2br(row.MessageText)
          try {
            row.MessageText = safeDecodeURIComponent(row.MessageText)
            row.MessageText = unicodeToEmojis(row.MessageText)
          } catch (error) {
            errorReporter(error)
          }
        })

        // focus on the textarea inside the modal
        $timeout(function () {
          document.getElementById('message').focus()
        }, 500)
      })
    }

    $scope.fetchSMSURL = function (sms) {
      return ApiSvc.fetch($scope, { fetchAPI: 'callresult/NetOwnerSMSURL?RecordID=' + sms.PERSONID, fetchTarget: 'URLandSettings', multiRow: true }).then(function () {
        if (!$scope.URLandSettings[0].url) {
          errorReporter('No SMS provider URL has been set (Check you have a virtual number assigned to your staff record).')
        }
        $scope.URLandSettings[0].url = $scope.URLandSettings[0].url.replace('#', $scope.URLandSettings[0].SMSNumber)
        $scope.smsCharLimit = $scope.URLandSettings[0].SMSCHARLIMIT
      })
    }

    $scope.sendWithCtrlEnter = function ($event, form) {
      if ($event.ctrlKey && $event.keyCode === 13) {
        $scope.sendMessage(form)
      }
    }

    $scope.openSMS = async function (sms) {
      $scope.selectedSMS = sms
      $scope.selectedSMS.read = true
      await $scope.fetchSMSConversation(sms)
      await $scope.fetchSMSURL(sms)
      // var choices = [{ desc: 'Close', type: 'danger', code: '' }]
      var choices = []
      var data = { ShowClassCodeBox: $scope.ShowClassCodeBox, ClassCodes: $scope.ClassCodes, loading: $scope.loadingPage, selectedSMS: $scope.selectedSMS, choices: choices }

      $scope.loadingPage = false
      setTimeout(function () {
        var scroll = 'message_' + $scope.smsConversation[$scope.smsConversation.length - 1].ContactEventID
        document.getElementById(scroll).scrollIntoView()
        twemoji.parse(document.body)
      }, 500)

      return FormSvc.modalInfo($scope, 'SMS', data, 'lg').catch(function (e) {})
    }

    /**
     * Submits the chat message by inserting it into the contact event table
     *
     * @param   {Object}  form  The form object that contains the form elms
     *
     * @return  {Promise}        Returns and promise once fetched.
     */
    $scope.sendMessage = function (form) {
      if ($scope.messageSending === true) {
        errorReporter('Please wait until your previous message has finished sending.')
        return false
      }

      if (!form.message || form.message == '') {
        errorReporter('Message cannot be empty.')
        return false
      }

      if ($scope.SelectedClassCode === '') {
        errorReporter('No contact event class code has been selected.')
        return false
      }

      if (form.message.length > $scope.smsCharLimit) {
        errorReporter('Message cannot be longer than ' + $scope.smsCharLimit + ' characters.')
        return false
      }

      if (form.message.length > $scope.smsHardCharLimit) {
        // Fail safe if the smsCharLimit is set to something higher than the smsHardCharLimit set by smsworks
        errorReporter('Message cannot be longer than ' + $scope.smsHardCharLimit + ' characters.')
        return false
      }

      $scope.messageSending = true

      var finalURL = $scope.URLandSettings[0].url.replace('~', encodeURIComponent(form.message)).replace(/''/g, "'")
      var RequestType = finalURL.indexOf('??') !== -1 ? 'POST' : 'GET'

      return $http({
        method: RequestType,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Cache-Control': undefined,
          Pragma: undefined,
          'x-auth': undefined
        },
        url: RequestType === 'GET' ? finalURL : finalURL.split('??')[0],
        data: RequestType === 'POST' ? finalURL.split('??')[1] : {}
      })
        .then(function () {
          var f = {}
          return ApiSvc.exec($scope, 'call/NetOwnerSMSInsert', {
            RecordID: $scope.selectedSMS.PERSONID,
            RecordType: 'P',
            MessageText: emojisToUnicode(form.message).replace(/'/g, "''"),
            CCode: $scope.SelectedClassCode
          })
        })
        .then(async function (x) {
          $scope.messageSending = false
          form.message = ''
          await $scope.fetchSMSConversation($scope.selectedSMS)
          setTimeout(function () {
            var scroll = 'message_' + $scope.smsConversation[$scope.smsConversation.length - 1].ContactEventID
            document.getElementById(scroll).scrollIntoView()
            twemoji.parse(document.body)
          }, 500)
        })
        .catch(function (e) {
          $scope.messageSending = false
          errorReporter(e)
        })
    }

    $scope.refresh = function () {
      return $scope.fetchSMS()
    }

    $scope.consultantSelected = function () {
      const newParams = new URLSearchParams({ consultant: $scope.selectedConsultant })
      window.history.pushState({}, '', '/sms?' + newParams.toString())

      $scope.fetchSMS()
    }

    consultantListSvc.get().then(function (res) {
      $scope.consultants = res

      // Add All to top of the list
      $scope.consultants.unshift({ id: 'all', name: 'All', isMe: false })
      angular.forEach(res, function (value) {
        if (value.isMe) {
          $scope.selectedConsultant = $scope.selectedConsultant ? $scope.selectedConsultant : value.id
          value.name = value.name + ' (me)'
        }
      })
    })
    $scope
      .fetchSMS()
      .then($scope.getContactClasses)
      .then(function () {
        var script = document.createElement('script')
        script.src = 'https://cdn.jsdelivr.net/npm/twemoji@14.0.2/dist/twemoji.min.js'
        script.type = 'text/javascript'
        script.onload = function () {
          twemoji.base = 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/'
          twemoji.ext = '.svg'
        }
        document.getElementsByTagName('head')[0].appendChild(script)
      })
  })
